// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'shield-solid';

export const Component = () => (
  <path d='M22.594 1H2v10.776c0 2.394 1.102 4.933 3.352 7.662 2.251 2.73 4.55 4.119 6.945 4.119 2.394 0 4.694-1.389 6.944-4.119 2.251-2.73 3.353-5.268 3.353-7.662V1ZM12.297 20.636c-1.677 0-3.352-.958-4.933-2.873-1.628-1.916-2.442-3.736-2.442-5.508V4.448c0-.335.191-.526.526-.526h4.886c.335 0 .479.191.479.526 0 .336-.144.48-.48.48H5.928v7.327c0 1.484.72 3.113 2.156 4.789 1.389 1.724 2.826 2.586 4.215 2.586.335 0 .479.143.479.479 0 .335-.144.526-.48.526Z' />
);

export const viewBox = '0 0 25 25';
